module.exports = __webpack_public_path__ + "static/media/blackberry.9558c672.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackberry.png
// module id = 31
// module chunks = 0